/**
 * Site Name Configuration
 * Auto-generated from: KEYWORD + NICHE + COUNTRY
 * Format: {keyword} {niche} {country}
 * This file is auto-generated - do not edit manually
 * 
 * Generated at: 2026-11-03T19:45:25.140Z
 */

// Site name auto-generated from keyword, niche, and country
export const SITE_NAME = 'meet latina australia'

export default SITE_NAME
